import { render } from "./PantryUsedUpCheckItem.vue?vue&type=template&id=5a8260d1&ts=true"
import script from "./PantryUsedUpCheckItem.vue?vue&type=script&lang=ts"
export * from "./PantryUsedUpCheckItem.vue?vue&type=script&lang=ts"

import "./PantryUsedUpCheckItem.vue?vue&type=style&index=0&id=5a8260d1&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__